<template>
    <div>
        <SearchBox ref="SearchBox">
            <el-form slot="form" :inline="true" ref="searchParams" :model="searchParams" label-width="80px"
                     class="unitWidth" size="small">
                <el-form-item label="所属工厂">
                    <el-select v-model="fcCode" placeholder="请选择工厂" @change="changeFactory(fcCode)" :clearable="isclear" filterable :disabled="ischeck">
                        <el-option v-for="factory in factoryList" :key="factory.factoryId" :label="factory.fcName"
                                   :value="factory.fcCode"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="部门">
                    <el-select v-model="depNo" placeholder="请选择部门" @change="changeBranch(depNo)" clearable filterable>
                        <el-option v-for="branch in branchList" :key="branch.deptCode" :label="branch.deptName"
                                   :value="branch.deptCode"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="科室">
                    <el-select v-model="ssoNo" placeholder="请选择科室" clearable filterable>
                        <el-option v-for="depart in departList" :key="depart.deptCode" :label="depart.deptName"
                                   :value="depart.deptCode"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="工号">
                    <el-input v-model="empNumber" placeholder="请输入工号"></el-input>
                </el-form-item>
                <el-form-item label="姓名">
                    <el-input v-model="userName" placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-form-item>
                    <div style="margin-left:42px">
                        <el-button size="small" type="primary" @click="searchTable">搜索</el-button>
                        <el-button size="small" @click="clearSelect">重置</el-button>
                    </div>
                </el-form-item>
            </el-form>
            <!-- <template slot="btns">
                <div style="float:right">
                    <el-button size="small" type="primary" @click="searchTable">搜索</el-button>
                    <el-button size="small" @click="clearSelect">重置</el-button>
                </div>
            </template> -->
        </SearchBox>
        <LabelContent title="建议列表" ref="LabelContent">
        </LabelContent>
        <div class="tableBox">
            <el-table stripe ref="multipleTable" :data="tableData" class="center">
                <!--                <el-table-column type="selection" width="55" />-->
                <!--<el-table-column type="index" label="序号" show-overflow-tooltip width="60"/>-->
                <el-table-column prop="fcName" label="工厂" show-overflow-tooltip/>
                <el-table-column prop="depName" label="部门" show-overflow-tooltip/>
                <el-table-column prop="ssoName" label="科室" show-overflow-tooltip/>
                <el-table-column prop="empNumber" label="工号" show-overflow-tooltip/>
                <el-table-column prop="userName" label="姓名" show-overflow-tooltip/>
                <el-table-column prop="oaFlg" label="是否被OA同步" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.oaFlg=='0'">否</span>
                        <span v-else>是</span>
                    </template>
                </el-table-column>
                <el-table-column prop="propose" label="改进建议" show-overflow-tooltip/>
                <el-table-column prop="solution" label="建议解决方案" show-overflow-tooltip/>
                <el-table-column prop="updFile" label="附件">
                    <template slot-scope="scope">
                        <el-image
                            v-if="scope.row.updFile"
                            style="width: 100px; height: 100px"
                            :src="scope.row.updFile.split(',')[0]"
                            :preview-src-list="scope.row.updFile.split(',')">
                        </el-image>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="paginationChange"
                @current-change="paginationCurrentChange"
                :current-page="searchParams.page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="searchParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="searchParams.pageCount"
            />
        </div>
    </div>
</template>

<script>

    export default {
        name: 'shiftList',
        data() {
            return {
                userName: '',
                ifAdd: false,
                userInfo: {},
                searchParams: {
                    param: {},
                    pageSize: 10,
                    page: 1,
                    pageCount: 0
                },
                empNumber: '',
                factoryTree: [],
                tableData: [],
                shiftForm: {
                    depNo: String,
                    depName: String
                },
                factoryData: [],
                role: [],
                ischeck: true,
                scopeDisabled: '',
                isclear: false,
                factoryList: [],
                fcCode: '',
                depNo: '',
                branchList: [],
                ssoNo: '',
                departList: [],
            }
        },
        mounted() {
            // this.userInfo = sessionStorage.getItem("userInfo")
            this.userInfo = this.$store.state.userInfo
            var role = this.userInfo.roles
            for (var i = 0; i < role.length; i++) {
                //所有工厂数据
                if (role[i].factoryId == 0) {
                    this.ischeck = false
                    this.role = role[i]
                    this.scopeDisabled = false
                    this.isclear = true
                    break
                } else {
                    if (this.userInfo.factoryId == role[i].factoryId) {
                        this.role = role[i]
                        this.searchBranchAndDep()
                    }
                }
            }
            this.getFactory()
        },
        methods: {
            clearSelect() {
                this.empNumber = ''
                this.userName = ''
                this.searchTable()
            },
            getFactory() {
                let options = {
                    methods: 'GET',
                    url: this.$api.getAllFactory
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.factoryList = []
                        var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
                        var aa = response.data
                        if (this.ischeck) {
                            for (var i = 0; i < aa.length; i++) {
                                for (let j = 0; j < userInfo.roles.length; j++) {
                                    if (aa[i].factoryId == userInfo.roles[j].factoryId) {
                                        this.factoryList.push(aa[i])
                                        this.fcCode = this.userInfo.fcCode
                                    }
                                }
                            }
                        } else {
                            this.factoryList = response.data
                        }
                    }
                    this.searchTable()
                })
            },
            /**
             *查询用户列表
             *  查询参数对象 searchParams
             **/
            searchTable() {
                let queryParams = {
                    pageSize: this.searchParams.pageSize,
                    pageNum: this.searchParams.page
                }
                if (this.fcCode != undefined && this.fcCode != '') {
                    queryParams['fcCode'] = this.fcCode
                }
                if (this.depNo != undefined && this.depNo != '') {
                    queryParams['depNo'] = this.depNo
                }
                if (this.ssoNo != undefined && this.ssoNo != '') {
                    queryParams['ssoNo'] = this.ssoNo
                }
                if (this.empNumber != null && this.empNumber != '') {
                    queryParams['empNumber'] = this.empNumber
                }
                if (this.userName != null && this.userName != '') {
                    queryParams['userName'] = this.userName
                }
                let options = {
                    method: 'GET',
                    params: queryParams,
                    url: this.$api.getSuggest
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.tableData = response.data.list
                        this.searchParams.pageCount = response.data.total
                    }
                })
            },
            changeFactory(val) {
                if (val) {
                    this.searchBranchAndDep()
                } else {
                    this.branchList = []
                }
                this.departList = []
                this.depNo = ''
                this.ssoNo = ''
            },
            changeBranch(val) {
                if (val) {
                    for (let i = 0; i < this.branchList.length; i++) {
                        if (val==this.branchList[i].deptCode && this.branchList[i].child) {
                            this.departList = this.branchList[i].child
                        }
                    }
                } else {
                    this.departList = []
                }
                this.ssoNo = ''
            },
            searchBranchAndDep() {
                let queryParams = {}
                if (this.fcCode != undefined && this.fcCode != '') {
                    queryParams['fcCode'] = this.fcCode
                }
                let options = {
                    method: 'GET',
                    params: queryParams,
                    url: this.$api.getBranchAndDep
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.branchList = response.data
                    }
                })
            },
            paginationChange(val) {
                this.searchParams.pageSize = val
                this.searchTable()
            },
            paginationCurrentChange(val) {
                this.searchParams.page = val
                this.searchTable()
            },
            selectChange() {
                this.$forceUpdate()
            }
        }
    }
</script>

<style scoped>
</style>
